import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';

const { devices, fontSizes, colors, spaces } = theme;

// eslint-disable-next-line prettier/prettier, react/display-name
const StyledBullet = styled.div`
  display: flex;
  align-items: start;
  margin-bottom: ${spaces.medium}px;
  @media ${devices.tablet} {
    align-items: center;
  }
`;
const StyledBulletIconContainer = styled.div`
  margin-right: ${spaces.regular}px;
  @media ${devices.tablet} {
    margin-right: ${spaces.smallX}px;
    svg {
      height: 36px;
    }
  }
`;

const StyledBulletText = styled.div`
  flex-grow: 1;
  font-family: 'Aeonik';
  font-style: normal;
  font-size: ${fontSizes.large8X}px;
  font-weight: 400;
  color: ${colors.gray[800]};
  width: 504px;
  @media ${devices.tablet} {
    font-size: ${fontSizes.large}px;
    width: 100%;
  }
`;
const Bullet = ({ icon, text }) => {
  return (
    <StyledBullet>
      {icon && <StyledBulletIconContainer>{icon}</StyledBulletIconContainer>}
      <StyledBulletText>{text}</StyledBulletText>
    </StyledBullet>
  );
};

export default Bullet;
